import React from "react";

export default function PrivacyPolicy() {
  return (
    <div
      className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
      data-aos="fade-up"
    >
      <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-2xl overflow-hidden">

        {/* Header */}
        <div className="bg-gradient-to-r from-orange-500 via-orange-600 to-amber-500 px-8 py-12 text-white">
          <h1 className="text-4xl font-bold mb-3">
            Privacy Policy
          </h1>

          <p className="text-lg text-orange-100 max-w-2xl">
            Please read our privacy policy carefully to understand
            how we collect, use, and protect your personal information.
          </p>
        </div>

        {/* Content */}
        <div className="p-8 md:p-12 space-y-10 text-gray-700">

          {/* Introduction */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              1. Introduction
            </h2>
            <p className="leading-7 text-gray-600">
              At <strong>HOLLY ZOLLY</strong>, we respect your
              privacy and are committed to protecting your
              personal information. This Privacy Policy explains
              how we collect, use, store, and safeguard your
              information when you interact with our services.
            </p>
          </section>

          {/* Information We Collect */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              2. Information We Collect
            </h2>

            <ul className="list-disc pl-6 space-y-3 text-gray-600">
              <li>Name, phone number, and email address.</li>
              <li>
                Property details shared for Vastu
                consultation purposes.
              </li>
              <li>
                Location details for site visits,
                online analysis, or consultations.
              </li>
              <li>
                Any information voluntarily shared
                during consultations or communication.
              </li>
            </ul>
          </section>

          {/* How We Use Information */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              3. How We Use Your Information
            </h2>

            <ul className="list-disc pl-6 space-y-3 text-gray-600">
              <li>
                To provide personalized Vastu
                consultation and reports.
              </li>

              <li>
                To communicate regarding
                appointments and services.
              </li>

              <li>
                To improve our customer experience
                and service quality.
              </li>

              <li>
                To comply with legal obligations
                and business requirements.
              </li>
            </ul>
          </section>

          {/* Data Security */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              4. Data Security
            </h2>

            <div className="bg-orange-50 border border-orange-200 rounded-xl p-5">
              <p className="leading-7 text-gray-700">
                We implement appropriate technical
                and organizational measures to
                protect your personal and
                property-related information
                from unauthorized access,
                misuse, disclosure, or loss.
              </p>
            </div>
          </section>

          {/* Third Party Sharing */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              5. Third-Party Sharing
            </h2>
            <p className="leading-7 text-gray-600">
              We do not sell, rent, or share your
              personal information with third
              parties, except where necessary
              for service delivery or as required
              by law.
            </p>
          </section>

          {/* User Rights */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              6. Your Rights
            </h2>
            <p className="leading-7 text-gray-600">
              You have the right to access,
              update, or request deletion of
              your personal information at
              any time by contacting us directly.
            </p>
          </section>

          {/* Policy Updates */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              7. Policy Updates
            </h2>
            <p className="leading-7 text-gray-600">
              We reserve the right to modify
              or update this Privacy Policy
              at any time. Changes will be
              reflected on this page, and
              continued use of our services
              signifies acceptance of updated
              terms.
            </p>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              8. Contact Us
            </h2>

            <p className="text-gray-600 leading-7">
              If you have any questions regarding
              this Privacy Policy or your data,
              please contact us.
            </p>

            <div className="mt-4 p-5 bg-gray-100 rounded-xl">
              <p>
                <span className="font-semibold">
                  Email:
                </span>{" "}
                vastukkalp2007gmail.com
              </p>

              <p>
                <span className="font-semibold">
                  Phone:
                </span>{" "}
                +91 99095 11961
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}